/** @file parentRotation: the world rotation a node's key is expressed in (its parent's, or the body facing). */
import type { Quat } from '@zilo/pose3d-math/quat/quat';
import { quatFromYawPitchRoll } from '@zilo/pose3d-math/quat/quatFromYawPitchRoll';
import type { PoseBuffer } from '@zilo/pose3d-pose/contract';
import { poseNode } from './poseNode';

/**
 * The effective parent's world rotation this frame; a root's key is turned only by the puppet transform, taken
 * here as the body facing (`facingDeg`, tilt ignored).
 */
export function parentRotation(pose: PoseBuffer, index: number, facingDeg: number): Quat {
  const parent = poseNode(pose, index).parent;
  return parent < 0 ? quatFromYawPitchRoll(facingDeg, 0, 0) : poseNode(pose, parent).q;
}
